// Open Quick Add modal for sibling products when clicking color swatches
(function () {
  /*
   * The listener below is registered on DOCUMENT, but this file is emitted by
   * card-product.liquid once per card-rendering SECTION -- and a browser runs
   * every <script> tag it parses, same src or not. So without this guard a page
   * accumulates one listener per section: measured 11 copies on a live PDP
   * (2026-09-08). Each one calls opener.click() on a swatch press, so a single
   * click opened the quick-add modal 11 times and fired 11 fetches.
   *
   * It stayed hidden because the handler only reaches that line on a swatch
   * carrying data-quick-add-url, which ONLY card-product-single.liquid emits --
   * on card-product cards every copy returns at the first line and the waste is
   * invisible. Any page that renders card-product-single cards pays it in full.
   *
   * Matches the guards on the sibling card scripts (card-color-swap.js's
   * __cardColorSwapInitialized, card-loop-video.js's __cardVideoJumpInitialized).
   * Window scope, not module scope, precisely because each copy is its own run.
   */
  if (window.__cardProductSwatchesInitialized) return;
  window.__cardProductSwatchesInitialized = true;

  function onClick(e) {
    const link = e.target.closest('.card__swatches .swatch-link[data-quick-add-url]');
    if (!link) return;
    // Allow middle-click or modified clicks to open in new tab
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;

    e.preventDefault();
    const card = link.closest('.product-card-wrapper, .card-wrapper');
    if (!card) {
      window.location.href = link.getAttribute('href');
      return;
    }
    const opener = card.querySelector('modal-opener[data-modal] button');
    if (!opener) {
      window.location.href = link.getAttribute('href');
      return;
    }
    // Set product URL for the modal fetch, then trigger open
    opener.setAttribute('data-product-url', link.dataset.quickAddUrl);
    opener.click();
  }

  document.addEventListener('click', onClick);
})();

